export const FEATURE_ROLLOUT_KEYS = {
	STRUCTURED_SUMMARY: 'structured_summary',
	INTERVIEW_AGENT: 'interview_agent',
	DELIVERABLES: 'deliverables',
} as const

export type FeatureRolloutKey = (typeof FEATURE_ROLLOUT_KEYS)[keyof typeof FEATURE_ROLLOUT_KEYS]
